<script setup lang="ts">
defineProps<{
  icon: IconPath
  text: string | number
}>()
</script>

<template>
  <div class="tag">
    <BaseIcon :name="icon" class="mr-2" :size="1.5" />
    <span class="tag__text">{{ text }}</span>
  </div>
</template>

<style>
.tag__text {
  padding: 0 1rem 0 0;
}
</style>
